import { get, post, downloadFile } from 'utils/api';
import { REPORT_LIST, REPORT_DOWNLOAD_REQUEST, GET_SIGNED_URL, GET_BULK_SIGNED_URL, GET_COMPANIES_BY_MODE, GET_REPORT_KEY_LIST, GET_TENANT_LIST } from './endpointURLs';

export const fetchReportList = (data) => {
  return get(`${REPORT_LIST}`, data);
};

export const fetchReportDownloadRequest = (data) => {
  return get(`${REPORT_DOWNLOAD_REQUEST}`, data);
};

export const createReportDownloadRequest = (data) => {
  return downloadFile(`${REPORT_DOWNLOAD_REQUEST}`, data);
};

export const getSignedUrl = (id) => {
  return get(`${GET_SIGNED_URL}/${id}`);
};

export const getBulkSignedUrl = (data) => {
  return post(`${GET_BULK_SIGNED_URL}`, data);
};

export const getCompaniesByMode = (data) => {
  return post(`${GET_COMPANIES_BY_MODE}`, data);
};

export const getReportByKeyName = (data) => {
  return post(`${GET_REPORT_KEY_LIST}`, data);
};

export const getTenants = (data) => {
  return post(`${GET_TENANT_LIST}`, data);
};

export const reportDownloadRequest = {
  fetchReportList,
  fetchReportDownloadRequest,
  createReportDownloadRequest,
  getSignedUrl,
  getBulkSignedUrl,
  getCompaniesByMode,
  getReportByKeyName,
  getTenants
};
